/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { FreightClaim } from "./FreightClaim";
import {
  FreightClaimFromJSON,
  FreightClaimFromJSONTyped,
  FreightClaimToJSON,
  FreightClaimToJSONTyped,
} from "./FreightClaim";
import type { QuoteGroup } from "./QuoteGroup";
import {
  QuoteGroupFromJSON,
  QuoteGroupFromJSONTyped,
  QuoteGroupToJSON,
  QuoteGroupToJSONTyped,
} from "./QuoteGroup";
import type { ShipmentReport } from "./ShipmentReport";
import {
  ShipmentReportFromJSON,
  ShipmentReportFromJSONTyped,
  ShipmentReportToJSON,
  ShipmentReportToJSONTyped,
} from "./ShipmentReport";
import type { TrackingLine } from "./TrackingLine";
import {
  TrackingLineFromJSON,
  TrackingLineFromJSONTyped,
  TrackingLineToJSON,
  TrackingLineToJSONTyped,
} from "./TrackingLine";
import type { CarrierRequestAudit } from "./CarrierRequestAudit";
import {
  CarrierRequestAuditFromJSON,
  CarrierRequestAuditFromJSONTyped,
  CarrierRequestAuditToJSON,
  CarrierRequestAuditToJSONTyped,
} from "./CarrierRequestAudit";
import type { Note } from "./Note";
import {
  NoteFromJSON,
  NoteFromJSONTyped,
  NoteToJSON,
  NoteToJSONTyped,
} from "./Note";
import type { Shipment } from "./Shipment";
import {
  ShipmentFromJSON,
  ShipmentFromJSONTyped,
  ShipmentToJSON,
  ShipmentToJSONTyped,
} from "./Shipment";
import type { BillingTabData } from "./BillingTabData";
import {
  BillingTabDataFromJSON,
  BillingTabDataFromJSONTyped,
  BillingTabDataToJSON,
  BillingTabDataToJSONTyped,
} from "./BillingTabData";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";
import type { ShipmentDocument } from "./ShipmentDocument";
import {
  ShipmentDocumentFromJSON,
  ShipmentDocumentFromJSONTyped,
  ShipmentDocumentToJSON,
  ShipmentDocumentToJSONTyped,
} from "./ShipmentDocument";

/**
 *
 * @export
 * @interface ShipmentBundle
 */
export interface ShipmentBundle {
  /**
   *
   * @type {Shipment}
   * @memberof ShipmentBundle
   */
  shipment: Shipment;
  /**
   *
   * @type {ShipmentReport}
   * @memberof ShipmentBundle
   */
  shipmentReport: ShipmentReport;
  /**
   *
   * @type {Array<Quote>}
   * @memberof ShipmentBundle
   */
  quotes: Array<Quote>;
  /**
   *
   * @type {Array<QuoteGroup>}
   * @memberof ShipmentBundle
   */
  quoteGroups: Array<QuoteGroup>;
  /**
   *
   * @type {Array<TrackingLine>}
   * @memberof ShipmentBundle
   */
  trackingLines: Array<TrackingLine>;
  /**
   *
   * @type {BillingTabData}
   * @memberof ShipmentBundle
   */
  billing: BillingTabData;
  /**
   *
   * @type {Array<ShipmentDocument>}
   * @memberof ShipmentBundle
   */
  documents: Array<ShipmentDocument>;
  /**
   *
   * @type {Array<Note>}
   * @memberof ShipmentBundle
   */
  notes: Array<Note>;
  /**
   *
   * @type {Array<FreightClaim>}
   * @memberof ShipmentBundle
   */
  claims: Array<FreightClaim>;
  /**
   *
   * @type {Array<CarrierRequestAudit>}
   * @memberof ShipmentBundle
   */
  carrierRequestAudits: Array<CarrierRequestAudit>;
  /**
   *
   * @type {Array<CustomerSpecificPricingAgreement>}
   * @memberof ShipmentBundle
   */
  customerSpecificPricingAgreements: Array<CustomerSpecificPricingAgreement>;
}

/**
 * Check if a given object implements the ShipmentBundle interface.
 */
export function instanceOfShipmentBundle(
  value: object,
): value is ShipmentBundle {
  if (!("shipment" in value) || value["shipment"] === undefined) return false;
  if (!("shipmentReport" in value) || value["shipmentReport"] === undefined)
    return false;
  if (!("quotes" in value) || value["quotes"] === undefined) return false;
  if (!("quoteGroups" in value) || value["quoteGroups"] === undefined)
    return false;
  if (!("trackingLines" in value) || value["trackingLines"] === undefined)
    return false;
  if (!("billing" in value) || value["billing"] === undefined) return false;
  if (!("documents" in value) || value["documents"] === undefined) return false;
  if (!("notes" in value) || value["notes"] === undefined) return false;
  if (!("claims" in value) || value["claims"] === undefined) return false;
  if (
    !("carrierRequestAudits" in value) ||
    value["carrierRequestAudits"] === undefined
  )
    return false;
  if (
    !("customerSpecificPricingAgreements" in value) ||
    value["customerSpecificPricingAgreements"] === undefined
  )
    return false;
  return true;
}

export function ShipmentBundleFromJSON(json: any): ShipmentBundle {
  return ShipmentBundleFromJSONTyped(json, false);
}

export function ShipmentBundleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentBundle {
  if (json == null) {
    return json;
  }
  return {
    shipment: ShipmentFromJSON(json["shipment"]),
    shipmentReport: ShipmentReportFromJSON(json["shipmentReport"]),
    quotes: (json["quotes"] as Array<any>).map(QuoteFromJSON),
    quoteGroups: (json["quoteGroups"] as Array<any>).map(QuoteGroupFromJSON),
    trackingLines: (json["trackingLines"] as Array<any>).map(
      TrackingLineFromJSON,
    ),
    billing: BillingTabDataFromJSON(json["billing"]),
    documents: (json["documents"] as Array<any>).map(ShipmentDocumentFromJSON),
    notes: (json["notes"] as Array<any>).map(NoteFromJSON),
    claims: (json["claims"] as Array<any>).map(FreightClaimFromJSON),
    carrierRequestAudits: (json["carrierRequestAudits"] as Array<any>).map(
      CarrierRequestAuditFromJSON,
    ),
    customerSpecificPricingAgreements: (
      json["customerSpecificPricingAgreements"] as Array<any>
    ).map(CustomerSpecificPricingAgreementFromJSON),
  };
}

export function ShipmentBundleToJSON(json: any): ShipmentBundle {
  return ShipmentBundleToJSONTyped(json, false);
}

export function ShipmentBundleToJSONTyped(
  value?: ShipmentBundle | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipment: ShipmentToJSON(value["shipment"]),
    shipmentReport: ShipmentReportToJSON(value["shipmentReport"]),
    quotes: (value["quotes"] as Array<any>).map(QuoteToJSON),
    quoteGroups: (value["quoteGroups"] as Array<any>).map(QuoteGroupToJSON),
    trackingLines: (value["trackingLines"] as Array<any>).map(
      TrackingLineToJSON,
    ),
    billing: BillingTabDataToJSON(value["billing"]),
    documents: (value["documents"] as Array<any>).map(ShipmentDocumentToJSON),
    notes: (value["notes"] as Array<any>).map(NoteToJSON),
    claims: (value["claims"] as Array<any>).map(FreightClaimToJSON),
    carrierRequestAudits: (value["carrierRequestAudits"] as Array<any>).map(
      CarrierRequestAuditToJSON,
    ),
    customerSpecificPricingAgreements: (
      value["customerSpecificPricingAgreements"] as Array<any>
    ).map(CustomerSpecificPricingAgreementToJSON),
  };
}
